'use client';

import { PersonForm } from '@/components/admin/people/PersonForm';

export default function AdminPersonNewPage() {
  return <PersonForm />;
}
